export default "__VITE_ASSET__Y9Cm4vFP__"